import { render, staticRenderFns } from "./CouponChangeHistoryTable.vue?vue&type=template&id=6689614c"
import script from "./CouponChangeHistoryTable.vue?vue&type=script&lang=js"
export * from "./CouponChangeHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports